// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumOwnerReferenceKind = {
  OwnerReferenceKindUser: 'User',
} as const;
export type EnumOwnerReferenceKind =
  (typeof EnumOwnerReferenceKind)[keyof typeof EnumOwnerReferenceKind];

export function instanceOfEnumOwnerReferenceKind(value: any): boolean {
  for (const key in EnumOwnerReferenceKind) {
    if (Object.prototype.hasOwnProperty.call(EnumOwnerReferenceKind, key)) {
      if (
        EnumOwnerReferenceKind[key as keyof typeof EnumOwnerReferenceKind] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EnumOwnerReferenceKindFromJSON(
  json: any,
): EnumOwnerReferenceKind {
  return EnumOwnerReferenceKindFromJSONTyped(json, false);
}

export function EnumOwnerReferenceKindFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnumOwnerReferenceKind {
  return json as EnumOwnerReferenceKind;
}

export function EnumOwnerReferenceKindToJSON(
  value?: EnumOwnerReferenceKind | null,
): any {
  return value as any;
}

export function EnumOwnerReferenceKindToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EnumOwnerReferenceKind {
  return value as EnumOwnerReferenceKind;
}
